import React from "react";
import Style from "./Navbar.module.scss";
import Toggler from "./home/Toggler";
import { HashLink as Link } from "react-router-hash-link";
import { Box } from "@mui/material";
import { info } from "../info/Info";
import { singlePage } from "../info/Info";

const links = [
    {
        name: "Home",
        to: "",
        active: "home"
    },
    {
        name: "News",
        to: "news",
        active: "news"
    },
    {
        name: "Research",
        to: "research",
        active: "research"
    },
    {
        name: info.initials,
        type: "initials",
        to: "",
        active: "home"
    },
    {
        name: "Publications",
        to: "portfolio",
        active: "portfolio"
    },
    {
        name: "Experience",
        to: "experience",
        active: "experience"
    },
    {
        name: "Mentorship",
        to: "mentorship",
        active: "mentorship"
    }
];

const scrollWidthOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -75;
    window.scrollTo({ top: yCoordinate + yOffset, behavior: "smooth" });
};

export default function Navbar({ darkMode, handleClick, active, setActive }) {
    return (
        <Box
            component={"nav"}
            width={"100%"}
            position={singlePage ? "fixed" : "relative"}
            className={darkMode ? Style.dark : Style.light}
            sx={{ zIndex: 1000, backdropFilter: "blur(10px)" }}
        >
            <Box
                component={"ul"}
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                flexWrap={"wrap"}
                rowGap={"0.4rem"}
                columnGap={{ xs: "1rem", sm: "2rem", md: "3rem" }}
                fontSize={{ xs: "0.85rem", md: "0.95rem" }}
                sx={{ py: 1, m: 0, px: 2, listStyle: "none" }}
            >
                {links.map((link, index) => (
                    <Box
                        key={index}
                        component={"li"}
                        className={link.active === active && !link.type ? Style.active : ""}
                        sx={{ borderImageSource: info.gradient }}
                    >
                        <Link
                            to={singlePage ? `#${link.to}` : `/${link.to}`}
                            scroll={(el) => scrollWidthOffset(el)}
                            smooth
                            onClick={() => setActive(link.active)}
                            className={Style.link}
                            style={{ textDecoration: "none", fontWeight: link.type ? 800 : 500 }}
                        >
                            {!link.type && <p style={{ padding: "0.25rem 0", margin: 0 }}>{link.name}</p>}
                            {link.type && <h1 style={{ fontSize: "1.1rem", margin: 0, padding: "0 0.5rem" }}>{link.name}</h1>}
                        </Link>
                    </Box>
                ))}
                <li>
                    <Toggler darkMode={darkMode} handleClick={handleClick} />
                </li>
            </Box>
        </Box>
    );
}
